<template>
  <!-- GDPR S7.3b-3 — the preference-link panel for one registry contact point, for a Privacy manager who may have
       no access to the CRM record. Modal drawer (focus in, Tab trap, Escape, focus back to the opener). Its z-index
       stays below dialogs (2400) and the panel's issuance drawer (3210), which open on top of it. -->
  <teleport to="body">
    <v-navigation-drawer :model-value="modelValue" location="right" temporary :width="560" class="ncrm-pref-links-host"
      role="dialog" :aria-modal="modelValue" aria-labelledby="ncrm-pref-links-host-title"
      @update:model-value="(open) => { if (!open) close(); }" @keydown.esc="close">
      <div v-if="modelValue && contactPoint" class="pa-5" @keydown.tab="trapFocus">
        <div class="d-flex align-center mb-3">
          <h3 id="ncrm-pref-links-host-title" class="text-h6 flex-grow-1">
            {{ $t("ncrm.contacts.dataProtection.record.preferenceLinks.title") }}
          </h3>
          <v-btn ref="close" icon="mdi-close" variant="text" :aria-label="$t('app.actions.close')" @click="close" />
        </div>
        <NcrmPrivacyPreferenceLinks :contact-point="contactPoint" embedded />
      </div>
    </v-navigation-drawer>
  </teleport>
</template>

<script>
import NcrmPrivacyPreferenceLinks from "@/components/ncrm/shared/NcrmPrivacyPreferenceLinks.vue";
import { trapDrawerFocus } from "@/Utile/drawerFocusTrap.mjs";

export default {
  name: "NcrmPrivacyPreferenceLinksDrawer",
  components: { NcrmPrivacyPreferenceLinks },
  props: {
    modelValue: { type: Boolean, default: false },
    contactPoint: { type: Object, default: null }, // { id, value } from the registry row
    opener: { default: null }, // element that opened the drawer; gets focus back on close
  },
  emits: ["update:modelValue"],
  watch: {
    modelValue(open) { if (open) this.$nextTick(() => this.$refs.close?.$el?.focus()); },
  },
  methods: {
    trapFocus: trapDrawerFocus,
    close() {
      const opener = this.opener;
      this.$emit("update:modelValue", false);
      this.$nextTick(() => { if (opener?.isConnected) opener.focus(); });
    },
  },
};
</script>

<style>
/* Unscoped: drawer and scrim are teleported siblings, fixed to the viewport (as in NcrmPrivacyPreferenceLinks).
   `+` targets only this drawer's own scrim: nested drawers teleport their scrims as later siblings too. */
.ncrm-pref-links-host.v-navigation-drawer {
  position: fixed !important; top: 0 !important; right: 0 !important; bottom: 0 !important; height: 100vh !important;
  max-width: 100vw; z-index: 2390 !important; text-align: left;
}
.ncrm-pref-links-host .v-navigation-drawer__content { overflow-y: auto; }
.ncrm-pref-links-host.v-navigation-drawer--active + .v-navigation-drawer__scrim {
  position: fixed !important; inset: 0 !important; z-index: 2389 !important;
}
</style>
